import lobby1 from "../img/lobby/1.png";
import lobby2 from "../img/lobby/2.png";
import lobby3 from "../img/lobby/3.png";
import lobby4 from "../img/lobby/4.png";
import lobby5 from "../img/lobby/5.png";
import lobby6 from "../img/lobby/6.png";
import lobby7 from "../img/lobby/7.png";
import lobby8 from "../img/lobby/8.png";
import lobby9 from "../img/lobby/9.png";
import lobby10 from "../img/lobby/10.png";

export const LOBBY_AVATAR_IMAGES = [
  lobby1,
  lobby2,
  lobby3,
  lobby4,
  lobby5,
  lobby6,
  lobby7,
  lobby8,
  lobby9,
  lobby10,
];

export function avatarSrcForIndex(index) {
  const i = Number(index);
  if (!Number.isFinite(i) || i < 1 || i > LOBBY_AVATAR_IMAGES.length) {
    return LOBBY_AVATAR_IMAGES[0];
  }
  return LOBBY_AVATAR_IMAGES[i - 1];
}

/** Pick a random avatar 1–10, preferring indices not already used. */
export function pickRandomAvatarIndex(usedIndices = []) {
  const used = new Set(
    (Array.isArray(usedIndices) ? usedIndices : [])
      .map((n) => Number(n))
      .filter((n) => n >= 1 && n <= LOBBY_AVATAR_IMAGES.length)
  );
  const available = [];
  for (let i = 1; i <= LOBBY_AVATAR_IMAGES.length; i += 1) {
    if (!used.has(i)) available.push(i);
  }
  const pool = available.length > 0 ? available : [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
  return pool[Math.floor(Math.random() * pool.length)];
}

export function playersToList(playersNode) {
  if (!playersNode || typeof playersNode !== "object") return [];
  return Object.entries(playersNode)
    .map(([id, row]) => ({
      id,
      name: String(row?.name || "Player").trim() || "Player",
      avatarIndex: Number(row?.avatarIndex) || 1,
      isHost: Boolean(row?.isHost),
      joinedAt: Number(row?.joinedAt) || 0,
    }))
    .sort((a, b) => a.joinedAt - b.joinedAt);
}
